export interface SettingsState {
  isMobile: boolean;
  isLoading: boolean;
  loadingMessage: string;
  loadingCanceled: boolean;
  loadingCancelable: boolean;
  disableBackdrop: boolean;
  disableAnimation: boolean;
}

export const initialSettingsState: SettingsState = {
  isMobile: false,
  isLoading: false,
  loadingMessage: '',
  loadingCanceled: false,
  loadingCancelable: false,
  disableBackdrop: false,
  disableAnimation: false,
};
